export default __webpack_public_path__ + "static/media/IMG0558.26786612.jpg";